var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { ToastGroup } from './ToastGroup';
import { AnimatePresence, motion } from 'framer-motion';
import { Portal } from '../../internal/Portal';
import { tokens } from '@servicetitan/tokens/core';
import { ToastGroupContext } from './ToastGroupContext';
export class Toast extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
        this.handleClose = (e) => {
            const { onClose } = this.props;
            this.clearSubscription();
            this.setState({ visible: false });
            if (onClose) {
                onClose(e);
            }
        };
        this.state = {
            visible: true,
        };
    }
    componentDidMount() {
        if (this.props.duration < 1)
            return;
        this.timeout = window.setTimeout(() => {
            this.handleClose();
        }, this.props.duration);
    }
    componentWillUnmount() {
        this.clearSubscription();
    }
    hasPrimaryAction() {
        return !!(this.props.primaryActionName && this.props.onPrimaryActionClick);
    }
    hasSecondaryAction() {
        return !!(this.props.secondaryActionName && this.props.onSecondaryActionClick);
    }
    clearSubscription() {
        if (this.timeout !== null) {
            window.clearTimeout(this.timeout);
        }
    }
    getIconNameByStatus() {
        switch (this.props.status) {
            case 'critical':
                return 'warning';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
        }
        // if status == 'info' || undefined
        return 'info';
    }
    render() {
        const _a = this.props, { primaryActionName, secondaryActionName, children, className, onPrimaryActionClick, onSecondaryActionClick, onClose, status, title } = _a, props = __rest(_a, ["primaryActionName", "secondaryActionName", "children", "className", "onPrimaryActionClick", "onSecondaryActionClick", "onClose", "status", "title"]);
        let portal = this.props.portal;
        const { isInToastGroup } = this.context;
        if (isInToastGroup) {
            // Ignore portal in a toast group.
            portal = undefined;
        }
        const ToastClasses = classnames('Toast', className, {
            'Toast--critical': status === 'critical',
            'Toast--info': status === 'info',
            'Toast--success': status === 'success',
            'Toast--warning': status === 'warning',
            'Toast--floating': portal,
        });
        const durationSlow = parseInt(tokens.durationSlow, 10) / 1000; // '300ms' -> 0.3
        const toastAnimation = {
            initial: { opacity: 0, y: 10, scale: 0.3 },
            animate: { opacity: 1, y: 0, scale: 1 },
            exit: { opacity: 0, y: 20, scale: 0.5 },
            transition: { type: 'easeInOut', duration: durationSlow },
        };
        const toast = (React.createElement(AnimatePresence, null,
            React.createElement(motion.div, Object.assign({ layout: true }, toastAnimation),
                React.createElement("div", Object.assign({ className: ToastClasses, "data-anvil-component": "Toast" }, props),
                    React.createElement(Icon, { className: "Toast__icon", name: this.getIconNameByStatus() }),
                    React.createElement("div", { className: "Toast__text" },
                        React.createElement("div", { style: {
                                paddingRight: onClose &&
                                    parseInt(tokens.spacing3, 10) * 2,
                            } },
                            React.createElement("div", { className: "Toast__title" }, title),
                            onClose && (React.createElement(Button, { "aria-label": "close toast", fill: "subtle", className: "Toast__close", iconName: "clear", size: "xsmall", onClick: this.handleClose }))),
                        this.props.children !== undefined && (React.createElement("div", { className: "Toast__description" }, this.props.children))),
                    (primaryActionName || secondaryActionName) && (React.createElement("div", { className: "Toast__action" },
                        this.hasSecondaryAction() && (React.createElement(Button, { fill: "subtle", small: true, onClick: onSecondaryActionClick }, secondaryActionName)),
                        this.hasPrimaryAction() && (React.createElement(Button, { fill: "outline", small: true, onClick: onPrimaryActionClick }, primaryActionName))))))));
        return (React.createElement(Portal, { conditional: !!portal, target: typeof portal !== 'boolean' ? portal : undefined }, toast));
    }
}
Toast.Group = ToastGroup;
Toast.contextType = ToastGroupContext;
Toast.defaultProps = {
    status: 'info',
    duration: 8000,
    portal: true,
};
//# sourceMappingURL=Toast.js.map